import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Circle, Group, Text } from 'react-konva';
/**
 * Иконка описания элемента, отображаемая в левом верхнем углу элемента
 *
 * @remarks
 * Иконка отображается в виде круга с буквой "i" внутри.
 * Позиционируется в левом верхнем углу элемента с небольшим смещением.
 *
 * @param props - Пропсы компонента
 */
export const DescriptionIcon = ({ x, y, size = 20, onClick, visible = true, }) => {
    // Позиционируем иконку внутри левого верхнего угла элемента
    // x и y - это координаты левого верхнего угла элемента
    let iconX = x + size / 2 / size;
    let iconY = y + size / 2 / size;
    let radius = size / 2;
    let iconColor = '#62B2F8';
    let iconBackgroundColor = '#142F44E1';
    let text = 'i';
    let strokeWidth = 0.6;
    if (!visible) {
        // return null;
        iconColor = '#33C4E9';
        iconBackgroundColor = '#4589FF';
        radius = (size / 2) * 0.3;
        iconX = x + (size / 2 / size) * -8;
        iconY = y + (size / 2 / size) * -2;
        text = '';
        strokeWidth = 0.1;
    }
    return (_jsxs(Group, { x: iconX, y: iconY, onClick: onClick, onTap: onClick, listening: true, onMouseEnter: (e) => {
            const stage = e.target.getStage();
            if (stage) {
                stage.container().style.cursor = 'pointer';
            }
        }, onMouseLeave: (e) => {
            const stage = e.target.getStage();
            if (stage) {
                stage.container().style.cursor = 'default';
            }
        }, children: [_jsx(Circle, { x: size / 2, y: size / 2, radius: radius, fill: iconBackgroundColor, stroke: iconColor, strokeWidth: strokeWidth, strokeScaleEnabled: true }), _jsx(Text, { x: size / 2, y: size / 2, text: text, fontSize: size * 0.9, fontFamily: "Edwardian Script ITC", fontStyle: "italic", fill: iconColor, align: "center", verticalAlign: "middle", offsetX: size * 0.15, offsetY: size * 0.45 })] }));
};
